export default __webpack_public_path__ + "static/media/TheTextileMagazine-28-03-2022-01042022184701.d5cd02ae.pdf";